import { useEffect } from "react";
import React, { PropsWithChildren } from "react";
import Util from "../Store/Util";

import * as S from "../Styles/Style";

interface DefaultType {
	isOpen: boolean;
	close: () => void;
	contents: { agree: boolean; type: string; explain: boolean };
}

export default ({
	isOpen,
	close,
	contents,
}: PropsWithChildren<DefaultType>) => {
	const closeEvent = () => {
		const timer = setTimeout(() => {
			close();
		}, 2000);
		return () => clearTimeout(timer);
	};

	useEffect(() => {
		if (isOpen) {
			closeEvent();
			return () => close();
		}
	}, [isOpen]);
	const typeText = () => {
		switch (contents.type) {
			case "smsSendYn":
				// 광고성 SMS
				return "SMS";
			case "pushSendYn":
				// 광고성 푸시
				return "Aplikasi";
			case "mailSendYn":
				// 광고성 Email
				return "Email";
			case "nightYn":
				// 야간 광고성
				return "iklan tengah mala";
		}
	};

	return (
		<S.toastContainer $isOpen={isOpen}>
			{/* 내용 */}
			<p>
				<S.subhead_3>
					Pengiriman notifikasi {typeText()}{" "}
					{/* disetujui : 동의 / dimatikan : 거부 */}
					{contents.agree ? "disetujui" : "dimatikan"}
					{/* 승인 / 거부 */}
				</S.subhead_3>
			</p>
			<div>
				<p>
					<S.subhead_4>Tanggal : {Util.getNow()}</S.subhead_4>
				</p>
			</div>
			{contents.explain && (
				<p>
					<S.bodyText_S color={S.color.gray400}>
						Pengaturan notifikasi: Akun Saya {">"} Persetujuan
						Pengiriman Marketing dan Notifikasi
					</S.bodyText_S>
				</p>
			)}
		</S.toastContainer>
	);
};
